// 詳細データ周りの型ガード
import { HOTLINE_INTERVIEW_STATUS_ACCEPT, HOTLINE_INTERVIEW_STATUS_COMPLETED, HOTLINE_INTERVIEW_STATUS_BLOCK, } from '@/feature/hotline/constant/interviewStatus';
import { PROFESSIONAL_HOTLINE_STATUS_OPEN } from '@/feature/hotline/professional/constant/status';
/**
 * 面談日程があるか
 */
export const isDetailDataHasRequestInterview = (detailData) => { var _a; return !!((_a = detailData.hotline_request) === null || _a === void 0 ? void 0 : _a.hotline_request_interview); };
/**
 * 相談日程確定判定 + 型ガード
 * @description 面談に関する情報が全てある + ステータスが受諾状態
 */
export const isScheduleFixedDetailData = (detailData) => {
    var _a;
    const requestInterview = (_a = detailData.hotline_request) === null || _a === void 0 ? void 0 : _a.hotline_request_interview;
    return (
    // 面談情報がある
    !!requestInterview &&
        // 面談情報があるか
        !!requestInterview.interviewed_from_at &&
        !!requestInterview.interviewed_to_at &&
        // 連絡先の情報があるか
        !!requestInterview.phone1 &&
        !!requestInterview.phone2 &&
        !!requestInterview.phone3 &&
        // ステータスが受諾・完了か
        requestInterview.status === HOTLINE_INTERVIEW_STATUS_ACCEPT.value);
};
/**
 * 初回返信後の判定 + 型ガード
 */
export const isFirstRepliedDetailData = (detailData) => 
// ステータスが未対応以外かつ相談申し込みデータがある
detailData.status !== PROFESSIONAL_HOTLINE_STATUS_OPEN.value &&
    !!detailData.hotline_request;
/**
 * 調整中かつ日程申請があるか
 */
export const isSchedulingDetailData = (detailData) => {
    var _a;
    const requestInterview = (_a = detailData.hotline_request) === null || _a === void 0 ? void 0 : _a.hotline_request_interview;
    return (
    // 面談情報がある
    !!requestInterview &&
        // 面談情報があるか
        !!requestInterview.interviewed_from_at &&
        !!requestInterview.interviewed_to_at &&
        // 完了・キャンセル以外のステータスか
        requestInterview.status !== HOTLINE_INTERVIEW_STATUS_BLOCK.value &&
        requestInterview.status !== HOTLINE_INTERVIEW_STATUS_COMPLETED.value);
};
